import { Module } from '@nestjs/common'
import { FetchReviewsCron } from './fetch-reviews.cron'

@Module({
	providers: [FetchReviewsCron],
})
export class ReportingCronModule {}
